import {MDCSwitch} from '@material/switch';
import {MDCDialog} from '@material/dialog';

export class VideoPopup{

    constructor(appManager){
        this.appManager = appManager
        this.currentContentURI

        this.initialise()
    }

    initialise(){
        this.VideoPopup = new MDCDialog(document.getElementById('VideoPopup'))
        this.VideoPopup.scrimClickAction=''
        this.VideoPopup.listen('MDCDialog:opened',()=> this.VideoPopup.scrimClickAction='close')
        this.VideoPopup.listen('MDCDialog:closed',()=> this.VideoPopup.scrimClickAction='')
        this.videoElement = document.getElementById('videoElement')
        this.videoSourceElement = document.getElementById('videoSourceElement')

        this.videoClose = document.getElementById('close-btn-video')
        this.videoClose.onclick = () => this.VideoPopup.close()
    }

    loadVideo(uri){
        this.currentContentURI = uri
        this.videoSourceElement.src = uri
        this.videoElement.load() 
        this.videoElement.pause()
        this.openVideoPopup()
    }

    openVideoPopup(){
        this.VideoPopup.scrimClickAction=''
        this.VideoPopup.open()
        this.VideoPopup.listen('MDCDialog:closed',()=> this.videoElement.pause())
    }
    closeVideoPopup(){
        
    }
}